import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import TopHeaderMenu from '../components/TopHeaderMenu';
import MsgNetLoading from '../components/MsgNetLoading';
import { formatMs } from '../utils/time';
import SharePanel from '../components/SharePanel';
import CONFIG from '../config';

const RESULTADOS_MOSTRAR = 15;
const POLL_INTERVAL = 5000;

class LocationDetailScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: null,
      isLoading: true,
      isLoadingMore: false,
      hasMoreResults: true,
      evento: null,
      showSharePanel: false,
      resultados: [],
      controles: [],
      resultadosLoaded: false,
      page: 1,
    };
    this.pollTimer = null;
  }

  toggleSharePanel() {
    this.setState(state => ({ showSharePanel: !state.showSharePanel }));
  }

  onClickBack() {
    this.props.navigate(`/${parseInt(this.props.params.eventoId, 10)}/locations`);
  }

  componentDidMount() {
    const locationId = parseInt(this.props.params.locationId, 10);
    this.fetchData(locationId, 1, false);
    this.pollTimer = setInterval(() => {
      if (!this.state.isLoadingMore) {
        this.fetchData(locationId, 1, true);
      }
    }, POLL_INTERVAL);
  }

  componentWillUnmount() {
    if (this.pollTimer) clearInterval(this.pollTimer);
  }

  fetchData(locationId, page, isRefresh) {
    fetch(`${CONFIG.API_URL}/api/1.0/live/location/${locationId}/?page=${page}`)
      .then(r => r.json())
      .then(data => {
        if (isRefresh) {
          // Refresh: reemplazar primera página manteniendo las extra
          const extra = this.state.resultados.slice(RESULTADOS_MOSTRAR);
          this.setState({
            resultados: [...data.resultados, ...extra],
            controles: data.controles,
          });
        } else if (page === 1) {
          this.setState({
            location: data.location,
            evento: data.evento,
            controles: data.controles,
            resultados: data.resultados,
            hasMoreResults: data.has_more,
            isLoading: false,
            resultadosLoaded: true,
            page: 1,
          });
        } else {
          this.setState(prev => ({
            resultados: [...prev.resultados, ...data.resultados],
            hasMoreResults: data.has_more,
            isLoadingMore: false,
            page,
          }));
        }
      })
      .catch(err => {
        console.error('live-location error:', err);
        this.setState({ isLoading: false, resultadosLoaded: true });
      });
  }

  loadMore() {
    const locationId = parseInt(this.props.params.locationId, 10);
    const nextPage = this.state.page + 1;
    this.setState({ isLoadingMore: true });
    this.fetchData(locationId, nextPage, false);
  }

  render() {
    const { evento, isLoading, resultados, controles, location, isLoadingMore, hasMoreResults, resultadosLoaded } = this.state;

    const getLastControlInLocation = (resultado) => {
      for (let i = 0; i < controles.length; i++) {
        if (resultado[`control_${controles[i].id}_tiempo`]) return controles[i];
      }
      return null;
    };

    return (
      <div className="min-h-screen bg-gray-900">
        <TopHeaderMenu
          competicion={location}
          evento={evento}
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toggleSharePanel.bind(this)}
        />
        {isLoading ? (
          <MsgNetLoading />
        ) : evento && evento.visible ? (
          resultadosLoaded && resultados.length && controles.length ? (
            <div className="pt-4">
              <div className="w-full">
                <div className="mx-auto max-w-5xl px-0 md:px-40">
                  {this.state.showSharePanel && (
                    <SharePanel
                      close={this.toggleSharePanel.bind(this)}
                      url={`/${evento.id}/locations/${location.id}`}
                      title={`Atletas pasando por ${location.codigo} en ${evento.nombre}`}
                    />
                  )}
                  <ul className="space-y-3">
                    {resultados.map((resultado, index) => {
                      const control = getLastControlInLocation(resultado);
                      const controlNombre = control ? control.nombre : '---';
                      const tiempo = control && resultado[`control_${control.id}_tiempo`] ? resultado[`control_${control.id}_tiempo`] : 0;
                      const puesto = control && resultado[`control_${control.id}_puesto`] ? resultado[`control_${control.id}_puesto`] : '---';
                      return (
                        <motion.li
                          key={`${resultado.dorsal}-${resultado.control_id}`}
                          className="list-none"
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.4, delay: index * 0.05 }}
                        >
                          <div className="py-3 px-4 md:px-6 hover:bg-slate-900/70 transition">
                            <div className="flex items-center justify-between mb-2">
                              <div className="text-sm font-semibold text-slate-400 font-montserrat">Dorsal {resultado.dorsal}</div>
                              <div className="text-sm font-mono font-semibold text-white">{formatMs(tiempo)}</div>
                            </div>
                            <div className="text-base text-white font-medium font-montserrat mb-1">{resultado.nombre} {resultado.apellidos}</div>
                            <div className="text-xs text-slate-400 font-montserrat">
                              A las {formatMs(resultado[`location_${location.id}_tiempo`])}
                              &nbsp;· en <span className="text-slate-300">{controlNombre}</span>
                              &nbsp;· puesto {puesto}
                            </div>
                          </div>
                        </motion.li>
                      );
                    })}
                  </ul>
                  {hasMoreResults && (
                    <div className="flex justify-center mt-6 pb-6">
                      {isLoadingMore ? <MsgNetLoading /> : (
                        <button onClick={this.loadMore.bind(this)} className="px-6 py-3 bg-ccnorte text-white rounded-lg shadow hover:bg-red-500 transition font-montserrat">
                          Cargar más
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : resultadosLoaded ? (
            <div className="text-center py-20 pt-20">
              <h2 className="text-lg font-montserrat text-slate-400">Sin resultados</h2>
            </div>
          ) : <MsgNetLoading />
        ) : (
          <div className="text-center py-20 pt-20">
            <h2 className="text-lg font-montserrat text-slate-400">No se ha podido encontrar el evento</h2>
          </div>
        )}
      </div>
    );
  }
}

function LocationDetailScreen() {
  const navigate = useNavigate();
  const params = useParams();
  return <LocationDetailScreenClass navigate={navigate} params={params} />;
}

export default LocationDetailScreen;
